<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">账户明细</div>
    <div class="bj-rows content-between bj-panl">
      <div style="text-align: center; flex: 1">
        <div class="name">可用金额：</div>
        <div class="label">{{ balance | balanceFilters }}</div>
      </div>
      <div style="text-align: center; flex: 1">
        <div class="name">冻结金额：</div>
        <div class="label">{{ freezeAmount | balanceFilters }}</div>
      </div>
      <div class="bj-col" style="flex: 1">
        <Button class="cz-btn" to="/my/finance/account/recharge">充值</Button>
        <Button class="tx-btn" to="/my/finance/account/cashout">提现</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAmountInfo } from "api/user.js";
import { mapState, mapMutations } from "vuex";
export default {
  name: "finance",
  filters:{
    balanceFilters(value){
      return !value ? '' : value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }
  },
  computed: {
    ...mapState(["freezeAmount", "balance"]),
  },
  created() {
    this.getInfo();
  },
  methods: {
    ...mapMutations(["MUT_AMOUNT"]),
    // 获取账户资金
    getInfo() {
      getAmountInfo().then((res) => {
        if (res.code === 200 && res.result) {
          this.MUT_AMOUNT(res.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .bj-panl{
    padding: 48px 0;
    background-color: #F04629;
    border-radius: 6px;
    .name{
      color: #fff;
      font-size: 18px;
      font-weight: 400;
      line-height: 35px;
    }
    .label{
      color: #fff;
      font-size: 50px;
      font-weight: 400;
    }
  }
  .cz-btn{
    width: 120px;
    height: 45px;
    line-height: 45px;
    background-color: #fff;
    border-radius: 45px;
    color: #F04629;
    &:hover{
      border-color: #fff;
    }
  }
  .tx-btn{
    margin-top: 20px;
    width: 120px;
    height: 45px;
    line-height: 45px;
    background-color: #F04629;
    border-radius: 45px;
    color: #fff;
    &:hover{
      border-color: #fff;
    }
  }
</style>
